import { FC } from 'react';
import { PunchupActionButton } from 'features/common/components/Punchup/primitives/buttons/PunchupActionButton';
import { PunchupAddButton } from 'features/common/components/Punchup/primitives/buttons/PunchupButton';
import { PunchupDivider } from 'features/common/components/Punchup/primitives/layout/PunchupDivider';
import { TicketsSectionTitleProps } from 'features/common/components/MultiButtonSectionTitle/types';
import { useResponsiveScreen } from 'hooks/useWindowSize';
import styles from './PunchupMultiButtonSectionTitle.module.css';

interface Props extends TicketsSectionTitleProps {
	/**
	 * When true (accordion mode): hides the title text and divider — only the action
	 * buttons are rendered. The accordion header already shows the section title.
	 */
	inAccordion?: boolean;
}

const PunchupMultiButtonSectionTitle: FC<Props> = ({ title, buttons, dataCy, inAccordion = false }: Props) => {
	const isAboveMobile = useResponsiveScreen();

	const buttonNodes = buttons.map(({ label, onClick, hidden = false, dataCy: btnDataCy, icon, isAdd }) => {
		if (hidden) return null;

		if (isAdd) {
			return (
				<PunchupAddButton key={label} onClick={onClick} type="button" data-cy={btnDataCy}>
					{label}
				</PunchupAddButton>
			);
		}
		return (
			<PunchupActionButton key={label} onClick={onClick} type="button" data-cy={btnDataCy}>
				{icon}
				{label}
			</PunchupActionButton>
		);
	});

	if (inAccordion) {
		return (
			<div className={`${styles.buttonContainer} ${styles.accordionMode}`} data-cy={dataCy}>
				{buttonNodes}
			</div>
		);
	}

	return (
		<div className={styles.sectionTitleContainer} data-cy={dataCy}>
			<div className={styles.row}>
				<div className={styles.title}>{title}</div>
				<div className={styles.buttonContainer}>{buttonNodes}</div>
			</div>
			{isAboveMobile && <PunchupDivider />}
		</div>
	);
};

export { PunchupMultiButtonSectionTitle };
